import { takeLatest, put, call } from 'redux-saga/effects';
import { apiErrorHandler } from '../Utils/apiErrorHandler';
import { chrApi } from '../../api/api';
import { fetchSurveyOutcomes, fetchSurveyOutcomesSuccess } from './slice';

function fetchOutcomesAnalyticsApi({ patientId, surveyId }) {
  return chrApi(
    'get',
    `encounter/survey_analytics/patient/${patientId}/survey/${surveyId}`,
    null,
    null
  );
}
function* fetchOutcomesAnalytics(action) {
  try {
    const apiResponse = yield call(fetchOutcomesAnalyticsApi, action.payload);
    yield put({
      type: fetchSurveyOutcomesSuccess.type,
      payload: { data: apiResponse.data }
    });
  } catch (e) {
    yield call(apiErrorHandler, e);
  }
}

export function* fetchOutcomeAnalyticsSaga() {
  yield takeLatest(fetchSurveyOutcomes.type, fetchOutcomesAnalytics);
}
